<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- FORMULÁRIO -->
<form *ngIf="!loading" [formGroup]="formSettings" class="mt-4 mb-4">

  <!-- Mensagem para não-ROOT -->
  <div *ngIf="!isRoot" class="mt-4 p-4 bg-gray-50 rounded-lg">
    <p class="text-sm text-westetics-neutral-600">
      Não há campos editáveis nesta seção. Clique em "Salvar" para finalizar.
    </p>
  </div>

  <!-- STATUS -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">
      Status da empresa
    </p>
    <div class="mt-3 flex gap-4">
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="status" value="true" />
        <span class="text-sm font-normal text-westetics-neutral-950">Ativo</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="status" value="false" />
        <span class="text-sm font-normal text-westetics-neutral-950">Bloqueado</span>
      </label>
    </div>
  </div>

  <!-- ANAMNESE CONTRATADA -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">
      Anamnese Contratada
    </p>
    <div class="mt-3 flex gap-4">
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="contractedAnamneseType" value="NOT_CONTRACTED" />
        <span class="text-sm font-normal text-westetics-neutral-950">Não contratado</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="contractedAnamneseType" value="VIRTUAL" />
        <span class="text-sm font-normal text-westetics-neutral-950">Virtual</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="contractedAnamneseType" value="PHYSICAL" />
        <span class="text-sm font-normal text-westetics-neutral-950">Física</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="contractedAnamneseType" value="BOTH" />
        <span class="text-sm font-normal text-westetics-neutral-950">Ambos</span>
      </label>
    </div>
  </div>

  <!-- FUNCIONALIDADES BETA -->
  <div class="border-b pb-4 mt-4" formGroupName="funcionalidadesBeta" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">Funcionalidades Beta</p>
    <div class="mt-2 flex flex-col gap-2">
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" formControlName="planoTratamento" />
        <span class="text-sm text-westetics-neutral-950">Plano de tratamento</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" formControlName="calculadora" />
        <span class="text-sm text-westetics-neutral-950">Calculadora</span>
      </label>
    </div>
  </div>

  <!-- MÓDULOS CONTRATADOS -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">Módulos Contratados*</p>
    <div class="mt-2 flex flex-col gap-2">
      <div *ngIf="modules.length === 0" class="text-neutral-400 text-sm">
        Nenhum módulo disponível.
      </div>
      <label *ngFor="let module of modules; let i = index" class="flex items-center gap-2 cursor-pointer">
        <input 
          type="checkbox" 
          [id]="'module-' + i" 
          [checked]="isModuleSelected(module)"
          (change)="onModuleChange($event, module)"
        />
        <span class="text-sm text-westetics-neutral-950">{{ module.description }}</span>
      </label>
    </div>
  </div>

  <!-- PACIENTE MODELO -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">Paciente Modelo</p>
    <div class="mt-2 flex gap-4">
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="pacienteModelo" value="ativo" />
        <span class="text-sm text-westetics-neutral-950">Ativo</span>
      </label>
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="radio" formControlName="pacienteModelo" value="desligado" />
        <span class="text-sm text-westetics-neutral-950">Desligado</span>
      </label>
    </div>
  </div>

  <!-- ANAMNESE PERSONALIZADA (apenas no modo de edição) -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot && isEditMode">
    <p class="font-medium text-sm text-westetics-neutral-950">Anamnese Personalizada</p>
    <div class="mt-3">
      <button 
        type="button"
        (click)="openAnamneseQuestionsModal()"
        class="px-4 py-2 text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white rounded-lg transition-colors"
      >
        Gerenciar perguntas Anamnese
      </button>
      <p class="text-xs text-westetics-neutral-600 mt-2">
        Configure perguntas específicas da clínica para personalizar a anamnese dos pacientes.
      </p>
    </div>
  </div>

  <!-- AUTOMAÇÕES (apenas no modo de edição) -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot && isEditMode">
    <p class="font-medium text-sm text-westetics-neutral-950">Automações</p>
    <div class="mt-3">
      <button 
        type="button"
        (click)="openAutomationModal()"
        class="px-4 py-2 text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white rounded-lg transition-colors"
      >
        Importar procedimentos
      </button>
      <p class="text-xs text-westetics-neutral-600 mt-2">
        Importe procedimentos em massa através de arquivo.
      </p>
    </div>
  </div>

  <!-- TOKEN AUTENTIQUE (apenas no modo de edição, ROOT) -->
  <div class="border-b pb-4 mt-4" *ngIf="isRoot && isEditMode">
    <p class="font-medium text-sm text-westetics-neutral-950">Token Autentique da Clínica</p>
    <p class="text-xs text-westetics-neutral-600 mt-1">
      Ao configurar o token, os documentos serão assinados automaticamente pela clínica.
      Documentos pendentes existentes também serão assinados retroativamente.
    </p>

    <!-- Token já configurado -->
    <div *ngIf="hasAutentiqueToken" class="mt-3 flex items-center gap-3">
      <span class="text-sm text-green-700 font-medium">Token cadastrado</span>
      <button
        type="button"
        (click)="removeAutentiqueToken()"
        [disabled]="autentiqueTokenSaving"
        class="px-4 py-2 text-sm border border-red-500 text-red-500 hover:bg-red-500 hover:text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        Remover
      </button>
    </div>

    <!-- Token não configurado -->
    <div *ngIf="!hasAutentiqueToken" class="mt-3 flex items-end gap-3">
      <div class="flex-1">
        <input
          type="password"
          [(ngModel)]="autentiqueToken"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Cole o token da API Autentique"
          class="w-full text-sm border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800"
          [disabled]="autentiqueTokenSaving"
        />
      </div>
      <button
        type="button"
        (click)="saveAutentiqueToken()"
        [disabled]="autentiqueTokenSaving"
        class="px-4 py-2 text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {{ autentiqueTokenSaving ? 'Salvando...' : 'Salvar Token' }}
      </button>
    </div>

    <p *ngIf="autentiqueTokenMessage" class="text-xs mt-2" [ngClass]="autentiqueTokenSuccess ? 'text-green-600' : 'text-red-600'">
      {{ autentiqueTokenMessage }}
    </p>
  </div>

  <!-- TEMPLATES ATIVOS / DISPONÍVEIS -->
  <div class="mt-4" *ngIf="isRoot">
    <p class="font-medium text-sm text-westetics-neutral-950">Templates</p>

    <div class="grid grid-cols-2 gap-4 mt-3">
        
      <!-- TEMPLATES DISPONÍVEIS -->
      <div class="border border-gray-200 rounded-lg p-3">
        <p class="text-xs font-medium text-westetics-neutral-950 mb-2">Disponíveis</p>
        <input
          type="text"
          placeholder="Buscar template..."
          [(ngModel)]="availableTemplatesSearch"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onAvailableTemplatesSearchChange()"
          class="w-full text-sm border border-gray-300 rounded-lg px-2 py-1 mb-2 outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800"
        />
        <div class="max-h-[200px] overflow-y-auto">
          <div *ngIf="templatesLoading" class="text-neutral-400 text-xs">Carregando...</div>
          <div *ngIf="!templatesLoading && availableTemplatesFiltered.length === 0" class="text-neutral-400 text-xs">
            Nenhum template disponível.
          </div>
          <label *ngFor="let template of availableTemplatesFiltered" class="flex items-center gap-2 cursor-pointer py-1">
            <input 
              type="checkbox" 
              [checked]="false"
              (change)="onTemplateChange($event, template, false)"
            />
            <span class="text-xs text-westetics-neutral-950">{{ template.name }}</span>
          </label>
        </div>
      </div>
      <!-- TEMPLATES ATIVOS -->
      <div class="border border-gray-200 rounded-lg p-3">
        <p class="text-xs font-medium text-westetics-neutral-950 mb-2">Ativos</p>
        <input
          type="text"
          placeholder="Buscar template..."
          [(ngModel)]="activeTemplatesSearch"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onActiveTemplatesSearchChange()"
          class="w-full text-sm border border-gray-300 rounded-lg px-2 py-1 mb-2 outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800"
        />
        <div class="max-h-[200px] overflow-y-auto">
          <div *ngIf="templatesLoading" class="text-neutral-400 text-xs">Carregando...</div>
          <div *ngIf="!templatesLoading && activeTemplatesFiltered.length === 0" class="text-neutral-400 text-xs">
            Nenhum template ativo.
          </div>
          <label *ngFor="let template of activeTemplatesFiltered" class="flex items-center gap-2 cursor-pointer py-1">
            <input 
              type="checkbox" 
              [checked]="true"
              (change)="onTemplateChange($event, template, true)"
            />
            <span class="text-xs text-westetics-neutral-950">{{ template.name }}</span>
          </label>
        </div>
      </div>

    </div>
  </div>

  <!-- ACTIONS (apenas no modo de criação) -->
  <div *ngIf="!isEditMode" class="flex justify-between mt-6">
    <button
      type="button"
      (click)="goBack()"
      class="w-[306px] py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border"
    >
      Voltar
    </button>

    <button
      type="button"
      (click)="saveAndFinish()"
      class="w-[306px] py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg"
    >
      Salvar
    </button>
  </div>

</form>

<!-- MODAIS -->
<app-anamnese-custom-questions-modal 
  [isOpen]="showAnamneseQuestionsModal" 
  [companyCnpj]="companyCnpj"
  (closeModal)="closeAnamneseQuestionsModal()">
</app-anamnese-custom-questions-modal>

<app-automation-services-modal
  *ngIf="showAutomationModal"
  [isOpen]="showAutomationModal"
  [companyCnpj]="companyCnpj"
  (closeModal)="closeAutomationModal()">
</app-automation-services-modal>
